/**
 * What a reader said about how a card went.
 *
 * Beside the card rather than on it. A rating is an input to grading and never
 * part of a card's state, and the two have different lifetimes. A card is
 * rewritten on every answer, and the rating that moved it is written once into
 * a log with no delete path.
 */

/**
 * The four answers, numbered as FSRS numbers them.
 *
 * This is the one value an optimiser reads back out of every event, and every
 * published implementation and every exported Anki revlog agrees on 1 through
 * 4. A vocabulary of our own here would buy readability in a console and cost a
 * mapping in the one place that has to agree with somebody else's arithmetic.
 * The card's own state is a string for the opposite reason, since nothing
 * outside this site reads one.
 */
export const ratings = { again: 1, hard: 2, good: 3, easy: 4 } as const;

/** What a reader said about how a card went. */
export type Rating = (typeof ratings)[keyof typeof ratings];

/**
 * Whether a number is a rating a reader can give.
 *
 * The check a route makes on a posted form. FSRS also numbers a manual
 * reschedule 0, which is not something a reader can press and is refused here.
 */
export function isRating(given: number): given is Rating {
  return Object.values<number>(ratings).includes(given);
}
